import { CustomVizRequest } from 'libs/end-to-end/src/custom-viz/CustomVizRequest';
import { z } from 'zod';
import { CustomVizId } from 'libs/end-to-end/src/custom-viz/CustomVizId';

export const ExternalStreamlitApp = z.object({
  id: z.string(),
  name: z.string(),
  streamlitSlug: z.string(),
  prototypeCustomVizId: CustomVizId.nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type ExternalStreamlitApp = z.infer<typeof ExternalStreamlitApp>;

export const ExternalStreamlitApps = z.array(ExternalStreamlitApp);

export type ExternalStreamlitApps = z.infer<typeof ExternalStreamlitApps>;

export const CreateOrUpdateExternalStreamlitAppRequest =
  ExternalStreamlitApp.pick({
    name: true,
    streamlitSlug: true,
    prototypeCustomVizId: true,
  });

export const CreateExternalStreamlitAppRequest =
  CreateOrUpdateExternalStreamlitAppRequest;

export type CreateExternalStreamlitAppRequest = z.infer<
  typeof CreateExternalStreamlitAppRequest
>;

export const UpdateExternalStreamlitAppRequest =
  CreateOrUpdateExternalStreamlitAppRequest;

export type UpdateExternalStreamlitAppRequest = z.infer<
  typeof UpdateExternalStreamlitAppRequest
>;

export const OrganizationExternalStreamlitAppEntitlement = z.object({
  id: z.string(),
  organizationId: z.string(),
  streamlitAppId: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type OrganizationExternalStreamlitAppEntitlement = z.infer<
  typeof OrganizationExternalStreamlitAppEntitlement
>;

export const OrganizationExternalStreamlitAppEntitlements = z.array(
  OrganizationExternalStreamlitAppEntitlement,
);

export type OrganizationExternalStreamlitAppEntitlements = z.infer<
  typeof OrganizationExternalStreamlitAppEntitlements
>;

export const MyOrganizationExternalStreamlitAppEntitlement = z.object({
  id: z.string(),
  name: z.string(),
  streamlitSlug: z.string(),
  prototypeCustomVizId: CustomVizId.nullable(),
});

export type MyOrganizationExternalStreamlitAppEntitlement = z.infer<
  typeof MyOrganizationExternalStreamlitAppEntitlement
>;

export const MyOrganizationExternalStreamlitAppEntitlements = z.array(
  MyOrganizationExternalStreamlitAppEntitlement,
);

export type MyOrganizationExternalStreamlitAppEntitlements = z.infer<
  typeof MyOrganizationExternalStreamlitAppEntitlements
>;

export const GrantOrganizationStreamlitAppAccessRequest = z.object({
  organizationId: z.string(),
  streamlitAppId: z.string(),
});

export type GrantOrganizationStreamlitAppAccessRequest = z.infer<
  typeof GrantOrganizationStreamlitAppAccessRequest
>;

export const StreamlitAppSignedUrlRequest = z.object({
  organizationId: z.string(),
  databaseId: z.string(),
  databaseRevisionId: z.string(),
  streamlitAppId: z.string(),
  customVizRequest: CustomVizRequest.nullable(),
});

export type StreamlitAppSignedUrlRequest = z.infer<
  typeof StreamlitAppSignedUrlRequest
>;

export const StreamlitAppSignedUrlResponse = z.object({
  signedUrl: z.string(),
});

export type StreamlitAppSignedUrlResponse = z.infer<
  typeof StreamlitAppSignedUrlResponse
>;
